import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  ldExpZsHeader: 'The Incredible Benefits of Advance Lending',
  ldExpZsDescription:
    'Offer your suppliers an advance payment to provide them with liquidity, build loyalty and thus be able to grow your business.',
  ldExpZsAction: 'Accept payment with credit',
  ldExpZsReject: 'Reject payment with credit',
  ldExpZsBenefit1:
    'We finance your suppliers POs/purchase orders up to 66% and their invoices up to 80%.',
  ldExpZsBenefit2: 'Monthly rates between 1.15% and 2%.',
  ldExpZsBenefit3: 'Financing in USD or MXN.',
  ldExpZsBenefit4:
    'The supplier can accept or reject this advance. If accepted, the discount would be made to the supplier at the time of settlement.',
  ldExpAcceptTitle: 'Accept payment with credit',
  ldExpRejectTitle: 'Reject payment with credit',
  ldExpAcceptDescription:
    'You are about to accept the payment with credit. Here is a brief description of the payment.',
  ldExpRejectDescription:
    'You are about to reject the payment with credit. Here is a brief description of the payment.',
  ldExpBenefitSender: 'Benefit sent by:',
  ldExpTotalAmount: 'Total amount',
  ldExpPO: 'Purchase order / Invoice',
  ldExptPercent: 'Percentage of advance',
  ldExpCost: 'Cost per advance',
  ldExpDesAmount: 'Final amount to receive',
  ldExpAcceptBtn: 'Accept payment with credit',
  ldExpRejectBtn: 'Reject payment with credit',
  ldExpCancelBtn: 'Cancel',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const LENDING_EXPORTER_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    ldExpZsHeader: 'Los increíbles beneficios del crédito para adelanto',
    ldExpZsDescription:
      'Ofrécele a tus proveedores un pago adelantado para proveerles liquidez, fidelizarlos y de esa forma poder crecer tu negocio.',
    ldExpZsAction: 'Acepta el pago con crédito',
    ldExpZsReject: 'Rechaza el pago con crédito',
    ldExpZsBenefit1:
      'Financiamos los POs/órdenes de compra de tus proveedores hasta en un 66% y sus facturas hasta en un 80%.',
    ldExpZsBenefit2: 'Tasas mensuales entre el 1.15% y el 2%.',
    ldExpZsBenefit3: 'Financiamiento en USD o MXN.',
    ldExpZsBenefit4:
      'El proveedor puede aceptar o rechazar este adelanto. Si acepta, el descuento se le haría al proveedor en el momento de la liquidación.',
    ldExpAcceptTitle: 'Acepta el pago con crédito',
    ldExpRejectTitle: 'Rechaza el pago con crédito',
    ldExpAcceptDescription:
      'Estás a punto de aceptar el pago con crédito. Aquí tienes una breve descripción del pago.',
    ldExpRejectDescription:
      'Estás a punto de rechazar el pago con crédito. Aquí tienes una breve descripción del pago.',
    ldExpBenefitSender: 'Beneficio enviado por:',
    ldExpTotalAmount: 'Monto total',
    ldExpPO: 'Órden de compra / PO / Factura',
    ldExptPercent: 'Porcentaje del adelanto',
    ldExpCost: 'Costo por adelanto',
    ldExpDesAmount: 'Monto final a recibir',
    ldExpAcceptBtn: 'Aceptar pago con crédito',
    ldExpRejectBtn: 'Rechazar pago con crédito',
    ldExpCancelBtn: 'Cancelar',
  },
};

export default LENDING_EXPORTER_LABELS;
